// extracted by mini-css-extract-plugin
export default {"footerLink":"lkkVBNgSYk5_DcXY6cRdH"};